package link.erpango.quip.utils

object FileUtils : IFileUtils {

    private var fileUtils: IFileUtils? = null

    fun create(fileUtils: IFileUtils) {
        this.fileUtils = fileUtils
    }

    override fun log(message: String) {
        fileUtils?.log(message)
    }

    override fun shareLogFile() {
        fileUtils?.shareLogFile()
    }

    override suspend fun pickFile(allowedTypes: List<String>): FileData? {
        return fileUtils?.pickFile(allowedTypes)
    }

    override fun saveBase64ToFile(base64: String, fileName: String): String {
        // Sanitize filename to prevent issues with special characters or paths
        val sanitizedFileName = fileName.replace(Regex("[^a-zA-Z0-9._-]"), "_")
        return fileUtils?.saveBase64ToFile(base64, sanitizedFileName) ?: ""
    }

    override fun readFileToBase64(filePath: String): String {
        return fileUtils?.readFileToBase64(filePath) ?: ""
    }

    override fun base64ToBitmap(base64: String): androidx.compose.ui.graphics.ImageBitmap? {
        return fileUtils?.base64ToBitmap(base64)
    }

    override fun fileExists(filePath: String): Boolean {
        return fileUtils?.fileExists(filePath) ?: false
    }
}